import { connect } from 'react-redux';
import {
  selectElementFromInternalReference,
  detachElementFromInternalReference,
  addElementToInternalReference,
} from 'store/actions/internal-reference-actions';
import { getInternalReferenceWithoutLoading } from 'store/actions/common/internal-reference-actions';
import { deallocateItems } from 'store/actions/statement-content-actions';
import { selectElementContentPanel } from 'store/actions/action-creators';

import InternalReferenceContent from 'components/feature/element-panel/internal-reference-panel/_internal-reference-panel-content-component';
import { updateWorkpaper } from '../../../store/actions/workpaper-actions';
import { attachTickmarkToElement } from '../../../store/actions/element-panel-actions';
import { getElementInternalReference } from 'store/actions/common/internal-reference-actions';
import { checkIfFeatureFlagEnabled } from 'store/actions/selected-statement-actions';

const mapStateToProps = (
  {
    data: {
      selectedStatement,
      elementPanel: { elementDetails },
      revision,
      internalReferencePanel: { internalReference },
      selectedStatement: { isOCR },
    },
    ui: {
      statementPage: { sectionsInView },
    },
  },
  ownProps,
) => ({
  ...ownProps,
  selectedStatement,
  elementDetails,
  internalReference,
  revision,
  sectionsInView,
  isOCR,
});
const mapDispatchToProps = {
  getInternalReferenceWithoutLoading,
  selectElementFromInternalReference,
  detachElementFromInternalReference,
  addSuggestionToInternalReference: addElementToInternalReference,
  selectElementContentPanel,
  deallocateItems,
  updateWorkpaper,
  attachTickmarkToElement,
  getElementInternalReference,
  checkIfFeatureFlagEnabled,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InternalReferenceContent);
